import { Button } from '@amzn/awsui-components-core';
import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import React, { useState } from 'react';
import ContentEngagementAdminModal from './ContentEngagementAdminModal';

interface ContentEngagementAdminLinkProps {
  workflow: ContentWorkflow;
}

const ContentEngagementAdminLink = ({ workflow }: ContentEngagementAdminLinkProps) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const showEngagementAdminModal = () => setModalVisible(true);
  const dismissModal = () => setModalVisible(false);

  if (workflow.engagementCount === 0) {
    return null;
  }

  return (
    <>
      <Button variant="link" onClick={showEngagementAdminModal}>
        {workflow.engagementCount}
      </Button>
      <ContentEngagementAdminModal
        contentId={workflow.contentId}
        onCancel={dismissModal}
        visible={modalVisible}
      />
    </>
  );
};

export default ContentEngagementAdminLink;
